export default __webpack_public_path__ + "static/media/country-flags.3694fad3.png";